import global from '../config/global';
import { ConstantsService } from '../core-js/src/services/constants.service';
import { SymmetricCryptoKey } from '../core-js/src/models/domain';
import { Utils } from '../core-js/src/misc/utils';

async function make_key(
  username,
  password,
  kdf = null,
  kdfIterations = null,
  kdfMemory = undefined,
  kdfParallelism = undefined
) {
  if (global.jsCore) {
    return await global.jsCore.cryptoService.makeKey(
      password,
      username,
      kdf,
      kdfIterations,
      kdfMemory,
      kdfParallelism
    )
  }
  return ''
}

async function unlock(data = {
  hashedPassword,
  keyB64,
  password,
  username,
  access_token,
  key,
  private_key,
  kdf,
  kdf_iterations,
  kdf_memory,
  kdf_parallelism
}) {
  const userInfo = global.store.getState().auth.userInfo;
  if (global.jsCore && userInfo) {
    await global.jsCore.cryptoService.clearKeys()
    let hashedPassword = data?.hashedPassword;
    let makeKey = data?.keyB64 ? new SymmetricCryptoKey(Utils.fromB64ToArray(data?.keyB64).buffer) : null
    if (data.password) {
      makeKey = await make_key(
        data.username,
        data.password,
        data.kdf,
        data.kdf_iterations,
        data.kdf_memory,
        data.kdf_parallelism
      )
      hashedPassword = await global.jsCore.cryptoService.hashPassword(data.password, makeKey)
    }
    await global.jsCore.tokenService.setTokens(data.access_token, null);
    await global.jsCore.userService.setInformation(
      global.jsCore.tokenService.getUserId(),
      data.username,
      data.kdf,
      data.kdf_iterations,
      data.kdf_memory,
      data.kdf_parallelism
    )
    await global.jsCore.cryptoService.setKey(makeKey)
    await global.jsCore.cryptoService.setKeyHash(hashedPassword)
    await global.jsCore.cryptoService.setEncKey(data.key)
    await global.jsCore.cryptoService.setEncPrivateKey(data.private_key)
    await global.jsCore.storageService.save(ConstantsService.lastActiveKey, new Date().getTime())
  }
}

async function lock () {
  if (global.jsCore) {
    await Promise.all([
      global.jsCore.cryptoService.clearKey(),
      global.jsCore.cryptoService.clearOrgKeys(),
      global.jsCore.cryptoService.clearKeyPair(),
      global.jsCore.cryptoService.clearEncKey()
    ])
    await global.jsCore.userService.setSecurityStamp(null)
    await global.jsCore.cipherService.clear()
    await global.jsCore.searchService.clearIndex()
  }
}

async function logout () {
  await lock();
  if (global.jsCore) {
    const userId = await global.jsCore.userService.getUserId()
    await global.jsCore.cryptoService.clearKeys()
    await global.jsCore.userService.clear()
    if (userId) {
      await global.jsCore.cipherService.clear(userId)
    }
  }
}

export default {
  make_key,
  unlock,
  lock,
  logout,
}
